import apiClient from './apiClient';

class DailyCoService {
  async createVideoCallRoom(appointmentId, participantName) {
    try {
      // apiClient.post() returns the data directly (not wrapped in response.data)
      const data = await apiClient.post('/videocalls/create-room', {
        appointmentId,
        participantName
      });
      
      if (import.meta.env.DEV) console.log('Daily.co API response:', data);
      
      // Ensure we have the required data
      if (!data) {
        throw new Error('No data received from Daily.co API');
      }
      
      // Check for roomUrl (our format) or url (Daily.co format)
      if (!data.roomUrl && !data.url) {
        throw new Error('No room URL in response');
      }
      
      // Normalize response format - use roomUrl if available, otherwise url
      return {
        roomUrl: data.roomUrl || data.url,
        roomName: data.roomName || data.name,
        token: data.token
      };
    } catch (error) {
      console.error('Error creating video call room:', error);
      console.error('Error details:', error.response?.data || error.message);
      throw error;
    }
  }
}

export default new DailyCoService();
